import ky from 'ky'

import { getJwt } from '../auth/auth-context'
import { API_BASE_URL, API_HOST } from './constants'

export const authenticatedApi = ky.create({
  prefix: `${API_HOST}${API_BASE_URL}`,
  timeout: 180000,
  hooks: {
    beforeRequest: [
      async ({ request }) => {
        const jwt = getJwt()
        if (jwt) {
          request.headers.set('Authorization', `Bearer ${jwt}`)
        }
      },
    ],
    afterResponse: [
      async ({ response }) => {
        if (!response.ok) {
          ;(response as any).payload = await response.json()
          return response
        }
      },
    ],
  },
})
